import { Maximize, Minimize } from 'lucide-react'
import { IconButton } from '@/components/play'
import { useFullscreen } from '@/lib/watch/useFullscreen'

/**
 * Full screen for the watch screen, beside the speaker on the canvas (docs/features/watch-experience.md): the page goes
 * full screen and lays the canvas over the whole screen; pressed again, or Escape, it comes back. Show it only where
 * `canGoFullscreen`.
 */
export function FullscreenToggle() {
  const { active, toggle } = useFullscreen()
  return (
    <IconButton variant="ghost" elevated size="compact" label={active ? 'Exit full screen' : 'Full screen'} onClick={toggle}>
      {active ? <Minimize /> : <Maximize />}
    </IconButton>
  )
}
